import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type TrackedWalletTableTradeCellColor = 'green' | 'red'
type TrackedWalletTableTradeCellProps = {
  volumeInUsd: BigNumber
  volumeCurrency: BigNumber
  number: number
  color: TrackedWalletTableTradeCellColor
} & ClassNameProps

export const TrackedWalletTableTradeCell: React.FC<
  TrackedWalletTableTradeCellProps
> = (props) => {
  return (
    <Root className={props.className}>
      <Top $color={props.color}>
        <Numeric
          value={props.volumeInUsd}
          preset="currency-amount-short"
          currency={'$'}
        />
      </Top>
      <Bottom>
        <Numeric value={props.volumeCurrency} preset="currency-amount-short" />
        {` / `}
        {props.number.toString()}
      </Bottom>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;

  height: 34px;
`
const Top = styled.div<{ $color: TrackedWalletTableTradeCellColor }>`
  color: ${(props) =>
    props.$color === 'green' ? 'var(--up-9)' : 'var(--down-9)'};

  font-size: 12px;
  font-weight: 500;
  line-height: normal;
`
const Bottom = styled.div`
  color: var(--text-9);

  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`
